import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import PageWrapper from './components/PageWrapper';
import LiveDashboard from './pages/liveDashboard';
import MetallurgicalAndKPI from './pages/metallurgicalAndKPI';
import MonthToDateProduction from './pages/monthToDateProduction';
import LabInspectionsMeasurements from './pages/labInspectionsMeasurements';
import ProcessEquipmentChecks from './pages/processEquipmentChecks';
import SetupPage from './pages/SetupPage';
import DevTestPage from './pages/devTestPage';
import DrivePage from './pages/DrivePage';
import DriXWidget from './components/DriXWidget';
import './index.css';

function App() {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch('/api/user.php?action=get_profile', { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch profile');
        return res.json();
      })
      .then(data => setUser(data.user || null))
      .catch(() => setUser(null));
  }, []);

  return (
    <div className="flex h-screen overflow-hidden text-white">
      <Sidebar />
      <div className="flex-1 flex flex-col p-4 overflow-hidden min-h-0">
        <Header />
        <div className="flex-1 overflow-y-auto mt-2 min-h-0">
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Navigate to="/live" replace />} />
              <Route path="/live" element={<PageWrapper><LiveDashboard /></PageWrapper>} />
              <Route path="/kpi" element={<PageWrapper><MetallurgicalAndKPI /></PageWrapper>} />
              <Route path="/production" element={<PageWrapper><MonthToDateProduction /></PageWrapper>} />
              <Route path="/lab" element={<PageWrapper><LabInspectionsMeasurements /></PageWrapper>} />
              <Route path="/process-checks" element={<PageWrapper><ProcessEquipmentChecks /></PageWrapper>} />
              <Route path="/drive" element={<PageWrapper><DrivePage /></PageWrapper>} />
              {/* Old AI page hidden — replaced by the DRi-X pop-up bubble (DriXWidget, mounted below).
                  To restore it, re-add `import DriXPage from './pages/DriXPage';` and render
                  <PageWrapper><DriXPage /></PageWrapper> here. */}
              <Route path="/drix" element={<Navigate to="/live" replace />} />
              <Route path="/setup" element={<PageWrapper><SetupPage /></PageWrapper>} />
              <Route path="/dev-test" element={<PageWrapper><DevTestPage /></PageWrapper>} />
            </Routes>
          </AnimatePresence>
        </div>
      </div>
      {/* Global DRi-X AI assistant — floating bubble, appears on every authenticated page. */}
      <DriXWidget user={user} />
    </div>
  );
}

export default App;
